import React from 'react';

const Dashboard = () => <div>Not yet built.</div>;

export default Dashboard;
